import { render, staticRenderFns } from "./PlusIcon.vue?vue&type=template&id=6bb92290"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb92290')) {
      api.createRecord('6bb92290', component.options)
    } else {
      api.reload('6bb92290', component.options)
    }
    module.hot.accept("./PlusIcon.vue?vue&type=template&id=6bb92290", function () {
      api.rerender('6bb92290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/PlusIcon.vue"
export default component.exports